/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import * as Constants from '../../../../SharedModules/AppConstants';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import createIcon from '../../../../assets/images/feather-settings.svg';
import CommonModal from './CommonModal';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import CreateContractModal from './CreateContractModal';
import {
  manuFactureHead,
  contractHead,
  drugFamilyHead,
  marketBasketHead,
} from './gridComponents/tableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  autoFormateDate,
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  selectionList,
  selectedType,
  getAllPlanTypeValue,
  searchContractActions,
  getRebateProgramCode,
  getSearchContractData,
  getContractQuarter,
  errorSearchContractActions,
  errorOtherSearchContractActions,
  errorMaintainContractActions,
  dispatchAllContractDetails,
  maintainContractActions,
  dispatchCellClick,
  handleErrorMessages,
  dispatchAllDrugFamiliesUsingMfgId,
  dispatchAllMfgIdUsingRebateProg,
  dispatchTabValue,
  dispatchNewContractSequenceNum,
  dispatchWriteOffDate,
  dispatchUndoWriteOffDate,
  dispatchDrugFamilyTable,
  dispatchSelectContractForInvoiceContact,
  dispatchSelectContractForDisputeContact,
  dispatchDefaultRpcData,
} from '../store/actions';
import {
  validDate,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  getPlanTypeDesc,
  storePriceLevelSearchData,
} from '../../RebatePriceLevel/store/actions';
import { generateQuarter } from '../../RebatePriceLevel/Components/utils';
import {
  MaxDate,
  MinDate,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';

const ContractSearch = (props) => {
  const dispatch = useDispatch();
  const selection_list = useSelector(
    (state) => state?.sharedState?.ContractReducer?.selection_list
  );
  const selected_type = useSelector(
    (state) => state?.sharedState?.ContractReducer?.selected_type
  );
  const getPlanTypeData = useSelector(
    (state) => state?.sharedState?.ContractReducer?.planType
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const errorsearchContract = useSelector(
    (state) => state.sharedState?.ContractReducer?.errorsearchContract
  );
  const errorOthersearchContract = useSelector(
    (state) => state.sharedState?.ContractReducer?.errorOthersearchContract
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const getSearchContractDetails = useSelector(
    (state) => state?.sharedState?.ContractReducer?.getSearchContractDetails
  );
  const getRebateProgramCodeValue = (values) =>
    dispatch(getRebateProgramCode(values));
  const rebateProgramCode = useSelector(
    (state) => state.sharedState?.ContractReducer?.rebateProgramCode?.data
  );
  const getInputValues = useSelector(
    (state) => state.sharedState.PriceDetails.priceLevelSearchdata
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [radioList, setRadioList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [selection, setSelection] = React.useState('');
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  const [planTypeOptionsCreatePopup, setPlanTypeOptionsCreatePopup] =
    React.useState([]);
  const gridRef = React.useRef();
  const [selectedRow, setSelectedRow] = React.useState();
  const [tableData, settableData] = React.useState([]);

  const [tableName, setTableName] = React.useState(
    'Contract Search - Manufacturer'
  );
  const [gridApi, setGridApi] = React.useState(null);
  const [openCreatePopup, setOpenCreatePopup] = useState(false);
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const [columnDefs, setColumnDefs] = React.useState(
    selected_type == Constants.MANUFACTURER_REBATE_ID
      ? manuFactureHead
      : selected_type == Constants.SEARCH_CONTRACT_ID
      ? contractHead
      : selected_type == Constants.CONTRACT_DRUG_FAMILTY_ID
      ? drugFamilyHead
      : selected_type == Constants.CONTRACT_MARKET_BASKET_ID
      ? marketBasketHead
      : null
  );

  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  React.useEffect(() => {
    if (searchContractState?.planType == '')
      dispatch(
        searchContractActions({
          ...searchContractState,
          planType: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
          rebateProgramCode: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
        })
      );
    dispatch(
      getPlanTypeDesc(
        userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD'
      )
    );
  }, [userDefaults]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  React.useEffect(() => {
    dispatch(dispatchWriteOffDate(''));
    dispatch(dispatchUndoWriteOffDate(''));
    getUserDefaultValues(logInUser);
    if (!searchContractState?.getQuarter && !searchContractState?.enableSave) {
      dispatch(getContractQuarter({}));
    }
    if (!searchContractState?.rebateProgramCode) {
      dispatch(
        searchContractActions({
          ...searchContractState,
          enableSave: true,
          rebateProgramCode: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
        })
      );
    }
  }, [!searchContractState?.enableSave]);
  React.useEffect(() => {
    dispatch(selectionList());
  }, []);
  React.useEffect(() => {
    if (
      searchContractState.planType === 'COMM' ||
      searchContractState.planType === 'SUPP'
    ) {
      if (
        rebateProgramCode &&
        rebateProgramCode.length > 0 &&
        getInputValues == undefined
      )
        dispatch(
          storePriceLevelSearchData({
            rebateProgramCd: '-1',
            planType: 'COMM',
            drugFamily: 'all',
            quarterValue: generateQuarter(),
            manufacturerGrid: [],
            drugfamilyId: null,
            loadMfgGrid: true,
            loadDrugFamilyGrid: true,
            loadDrugTable: false,
            rebateList: rebateProgramCode,
          })
        );
      else if (
        rebateProgramCode &&
        rebateProgramCode.length > 0 &&
        getInputValues !== undefined
      )
        dispatch(
          storePriceLevelSearchData({
            ...getInputValues,
            rebateList: rebateProgramCode,
          })
        );
    } else {
      dispatch(
        storePriceLevelSearchData({
          rebateProgramCd: '-1',
          planType: 'COMM',
          drugFamily: 'all',
          quarterValue: generateQuarter(),
          manufacturerGrid: [],
          drugfamilyId: null,
          loadMfgGrid: true,
          loadDrugFamilyGrid: true,
          loadDrugTable: false,
        })
      );
    }
  }, [rebateProgramCode]);
  React.useEffect(() => {
    setSelection(selected_type);
  }, [selected_type]);

  React.useEffect(() => {
    setRadioList(selection_list);
  }, [selection_list]);
  // handle all plan type get service
  React.useEffect(() => {
    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getAllPlanTypeValue());
    }
    handleScrollToEvent();
  }, []);
  // set play type list
  React.useEffect(() => {
    const planList = getPlanTypeData?.PLAN_TYPE_CD?.map((obj) => {
      return {
        name:
          obj?.codeValueID?.codeValue === 'FD'
            ? 'Medicaid'
            : obj.shortDescription,
        value: obj.codeValueID.codeValue,
      };
    });
    setPlanTypeOptions(planList);
    const planListCreatePopup = getPlanTypeData?.PLAN_TYPE_CD?.map((obj) => {
      return {
        name:
          obj?.codeValueID?.codeValue === 'FD'
            ? 'Medicaid'
            : obj.shortDescription,
        value: obj.codeValueID.codeValue,
      };
    });
    const listPlanType = planListCreatePopup?.filter((obj) => {
      if (obj.value !== 'FD') return obj;
    });
    setPlanTypeOptionsCreatePopup(listPlanType);
  }, [getPlanTypeData]);
  // handing highlight tab
  React.useEffect(() => {
    if (selected_type === 'MF') {
      if (errorsearchContract && errorsearchContract.length > 0) {
        tabHighLigther('/contract', true);
      } else {
        tabHighLigther('/contract', false);
      }
    } else if (
      errorOthersearchContract &&
      errorOthersearchContract.length > 0
    ) {
      tabHighLigther('/contract', true);
    } else {
      tabHighLigther('/contract', false);
    }
  }, [
    JSON.stringify(errorsearchContract),
    JSON.stringify(errorOthersearchContract),
    selected_type,
  ]);
  // use effect for getting the plan type
  React.useEffect(() => {
    if (searchContractState?.planType) {
      getRebateProgramCodeValue(searchContractState.planType);
    }
  }, [searchContractState?.planType]);
  React.useEffect(() => {
    if (selected_type == Constants.MANUFACTURER_REBATE_ID) {
      setColumnDefs(manuFactureHead);
      setTableName('Contract Search - Manufacturer');
      if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.mfgData.length > 0
      ) {
        settableData(getSearchContractDetails[0]?.mfgData);
      } else if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.mfgData?.length == 0
      ) {
        settableData([]);
      }
    } else if (selected_type == Constants.SEARCH_CONTRACT_ID) {
      setColumnDefs(contractHead);
      setTableName('Contract Search - Contract');
      if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        (getSearchContractDetails[0]?.contractData === null ||
          getSearchContractDetails[0]?.contractData === undefined)
      ) {
        settableData([]);
      } else if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.contractData.length > 0
      ) {
        settableData(getSearchContractDetails[0]?.contractData);
      } else if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.contractData.length == 0
      ) {
        settableData([]);
        const errorShown = [...errorOthersearchContract];
        const error = [
          ...new Set([
            ...errorShown,
            constantMessageData.NO_RECORDS_FOUND_CONTRACT,
          ]),
        ];
        dispatch(errorOtherSearchContractActions(error));
      }
    } else if (selected_type === Constants.CONTRACT_DRUG_FAMILTY_ID) {
      setColumnDefs(drugFamilyHead);
      setTableName('Contract Search - Drug Family');
      if (
        getSearchContractDetails &&
        getSearchContractDetails?.length > 0 &&
        getSearchContractDetails[0]?.drugFamilyData.length > 0
      ) {
        settableData(getSearchContractDetails[0]?.drugFamilyData);
      } else if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.drugFamilyData.length == 0
      ) {
        settableData([]);
        const errorShown = [...errorOthersearchContract];
        const error = [
          ...new Set([
            ...errorShown,
            constantMessageData.NO_RECORDS_FOUND_CONTRACT,
          ]),
        ];
        dispatch(errorOtherSearchContractActions(error));
      }
    } else if (selected_type == Constants.CONTRACT_MARKET_BASKET_ID) {
      setColumnDefs(marketBasketHead);
      setTableName('Contract Search - Market Basket');
      if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.marketBasketData.length > 0
      ) {
        settableData(getSearchContractDetails[0]?.marketBasketData);
      } else if (
        getSearchContractDetails &&
        getSearchContractDetails.length > 0 &&
        getSearchContractDetails[0]?.marketBasketData.length == 0
      ) {
        settableData([]);
        const errorShown = [...errorOthersearchContract];
        const error = [
          ...new Set([
            ...errorShown,
            constantMessageData.NO_RECORDS_FOUND_CONTRACT,
          ]),
        ];
        dispatch(errorOtherSearchContractActions(error));
      }
    }
  }, [getSearchContractDetails]);
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      settableData([]);
      dispatch(
        searchContractActions({
          ...searchContractState,
          planType: value,
          rebateProgramCode: '-1',
        })
      );
    }
  };
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const onSelectionChanged = useCallback(
    (val) => {
      const selectedRows = val.api.getSelectedRows();
    },
    [gridApi]
  );
  const createNewContract = () => {
    setOpenCreatePopup(true);
  };
  const onBlurField = (e, name) => {
    const data = { ...searchContractState };
    let error = [];
    if (name === 'rebateProgramCode') {
      data.errorRebateProg = e.target.value === '-1';
      const errorShown = [...errorsearchContract];
      error =
        e.target.value === '-1'
          ? [
              ...new Set([
                ...errorsearchContract,
                constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
              ]),
            ]
          : errorShown.filter(
              (e) => e !== constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
            );
    }
    dispatch(searchContractActions(data));
    dispatch(errorSearchContractActions(error));
  };
  const onChangeDetailsField = (e, name) => {
    const data = {
      ...searchContractState,
      enableSave: true,
      [name]: e.target.value,
    };
    dispatch(searchContractActions(data));
  };
  const onBlurQuarter = (event, name) => {
    const dateFromPicker = event.target.value.toUpperCase();
    const regexNumber = /^[0-9/]+$/;
    if (dateFromPicker.includes('Q') || dateFromPicker.includes('q')) {
      const dateUpperCase = dateFromPicker.toUpperCase();
      const splitYear = dateUpperCase.split('Q') || dateUpperCase.split('q');
      const checkQuater = splitYear[0] <= 4;
      if (checkQuater) {
        if (
          dateFromPicker.length === 6 &&
          regexNumber.test(splitYear[1]) &&
          splitYear[1] >= 1991 &&
          splitYear[1] <= 9999
        ) {
          const data = {
            ...searchContractState,
            [name]: autoFormateDate(event.target.value.toUpperCase()),
            errorInvalidQuarter: false,
            errorQuarterRequired: false,
            enableSave: true,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorsearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.VALIDATE_QUARTER_VALUE
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.QUARTER_REQUIRED
          );
          dispatch(errorSearchContractActions(error));
        } else if (
          dateFromPicker.length === 4 &&
          regexNumber.test(splitYear[1])
        ) {
          const data = {
            ...searchContractState,
            [name]: autoFormateDate(event.target.value.toUpperCase()),
            errorInvalidQuarter: false,
            errorQuarterRequired: false,
            enableSave: true,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorsearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.VALIDATE_QUARTER_VALUE
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.QUARTER_REQUIRED
          );
          dispatch(errorSearchContractActions(error));
        } else {
          const data = {
            ...searchContractState,
            [name]: autoFormateDate(event.target.value.toUpperCase()),
            errorInvalidQuarter: true,
            errorQuarterRequired: false,
            enableSave: true,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorsearchContract];
          let error = errorShown.filter(
            (e) => e !== constantMessageData.QUARTER_REQUIRED
          );
          error = [
            ...new Set([...error, constantMessageData.VALIDATE_QUARTER_VALUE]),
          ];
          dispatch(errorSearchContractActions(error));
        }
      } else {
        const data = {
          ...searchContractState,
          [name]: autoFormateDate(event.target.value.toUpperCase()),
          errorInvalidQuarter: true,
          errorQuarterRequired: false,
          enableSave: true,
        };
        dispatch(searchContractActions(data));
        const errorShown = [...errorsearchContract];
        let error = errorShown.filter(
          (e) => e !== constantMessageData.QUARTER_REQUIRED
        );
        error = [
          ...new Set([...error, constantMessageData.VALIDATE_QUARTER_VALUE]),
        ];
        dispatch(errorSearchContractActions(error));
      }
    } else if (dateFromPicker === '') {
      const data = {
        ...searchContractState,
        [name]: event.target.value,
        errorQuarterRequired: true,
      };
      dispatch(searchContractActions(data));
      const errorShown = [...errorsearchContract];
      const error1 = errorShown.filter(
        (e) => e !== constantMessageData.VALIDATE_QUARTER_VALUE
      );
      const error = [
        ...new Set([...error1, constantMessageData.QUARTER_REQUIRED]),
      ];
      dispatch(errorSearchContractActions(error));
    } else {
      const data = {
        ...searchContractState,
        [name]: event.target.value,
        errorInvalidQuarter: true,
        errorQuarterRequired: false,
      };
      dispatch(searchContractActions(data));
      const errorShown = [...errorsearchContract];
      let error = errorShown.filter(
        (e) => e !== constantMessageData.QUARTER_REQUIRED
      );
      error = [
        ...new Set([...error, constantMessageData.VALIDATE_QUARTER_VALUE]),
      ];
      dispatch(errorSearchContractActions(error));
    }
  };
  const handleChangeDate = (date, name) => {
    if (date !== 'Invalid Date') {
      dispatch(
        searchContractActions({
          ...searchContractState,
          errorDateRequired: false,
          errorInvalidDate: false,
          [name]: moment(date).format('MM/DD/YYYY'),
        })
      );
      dispatch(errorOtherSearchContractActions([]));
    }
  };
  const onClickCreateContractDailog = () => {
    dispatch(dispatchCellClick(true));
    resetFieldData();
    dispatch(dispatchTabValue('one'));
    dispatch(dispatchAllContractDetails({}));
    dispatch(dispatchDefaultRpcData({}));
    dispatch(handleErrorMessages([]));
    redirectURLLink('/createContract', 'Maintain Contract', props.history);
    dispatch(dispatchAllMfgIdUsingRebateProg([]));
    dispatch(dispatchAllDrugFamiliesUsingMfgId([]));
  };

  const cellClickedListener = (e) => {
    const mgfId = '';
    searchContractState.contractType = 'onSelect';
    resetFieldData();
    if (selected_type == Constants.MANUFACTURER_REBATE_ID) {
      searchContractState.selectedContractType = 'mfgId';
      searchContractState.selectedRowData = e.data.mfgId;
      searchContractState.selectedContractId = e.data.contractSeqNum;
    } else if (selected_type == Constants.SEARCH_CONTRACT_ID) {
      searchContractState.selectedContractType = 'contractId';
      searchContractState.selectedRowData = e.data.contractSeqNum;
      searchContractState.selectedContractId = e.data.contractSeqNum;
    } else if (selected_type == Constants.CONTRACT_DRUG_FAMILTY_ID) {
      searchContractState.selectedContractType = 'drugFamilyId';
      searchContractState.selectedRowData = e.data.familySeqNum;
      searchContractState.selectedContractId = e.data.contractSeqNum;
    } else if (selected_type == Constants.CONTRACT_MARKET_BASKET_ID) {
      searchContractState.selectedContractType = 'marketBasketId';
      searchContractState.selectedRowData = e.data.marketBasketSeqNum;
      searchContractState.selectedContractId = e.data.contractSeqNum;
    }
    dispatch(handleErrorMessages([]));
    dispatch(dispatchAllContractDetails({}));
    dispatch(dispatchWriteOffDate(''));
    dispatch(dispatchUndoWriteOffDate(''));
    dispatch(dispatchNewContractSequenceNum(''));
    dispatch(errorMaintainContractActions([]));
    dispatch(dispatchCellClick(true));
    dispatch(dispatchDefaultRpcData({}));
    dispatch(dispatchDrugFamilyTable([]));
    dispatch(dispatchSelectContractForInvoiceContact([]));
    dispatch(dispatchSelectContractForDisputeContact([]));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/createContract',
      value: 'Maintain Contract',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/createContract',
    });
  };
  const onSearchManufacturerBtn = () => {
    // handleClearFilter();
    if (searchContractState?.rebateProgramCode === '-1') {
      const data = { ...searchContractState };
      data.errorRebateProg = true;
      dispatch(searchContractActions(data));
    }
    if (searchContractState.getQuarter === '') {
      const data = { ...searchContractState };
      data.errorQuarterRequired = true;
      dispatch(searchContractActions(data));
    } else if (
      !searchContractState.errorInvalidQuarter &&
      !searchContractState.errorQuarterRequired &&
      !searchContractState.errorRebateProg &&
      searchContractState.rebateProgramCode !== '-1' &&
      searchContractState.getQuarter !== ''
    ) {
      const newData = {
        searchType: selected_type,
        rebateProgram: searchContractState.rebateProgramCode,
        quarter: searchContractState.getQuarter,
        asOfDate: null,
      };
      dispatch(getSearchContractData(newData));
    }
  };
  const onSearchOtherContract = () => {
    // handleClearFilter()
    if (searchContractState.searchContractDate === '') {
      const data = { ...searchContractState };
      data.errorDateRequired = true;
      dispatch(searchContractActions(data));
    }
    if (
      !searchContractState.errorInvalidDate &&
      !searchContractState.errorDateRequired &&
      !searchContractState.minDateError &&
      searchContractState.searchContractDate !== ''
    ) {
      const newData = {
        searchType: selected_type,
        rebateProgram: null,
        quarter: null,
        asOfDate: searchContractState.searchContractDate,
      };
      dispatch(getSearchContractData(newData));
    }
  };
  const validateDateFormatOnBlur = (event, name) => {
    if (event.target.value !== '') {
      const errorMessages = [];
      let errorDate = false;
      const regex = new RegExp(/^[0-9/]+$/);
      const invoiceDate = event.target.value;
      const sptDate =
        invoiceDate && invoiceDate.includes('_')
          ? invoiceDate.split('_')
          : invoiceDate;
      const splitDate =
        sptDate && sptDate.length > 0 && sptDate[0].includes('/')
          ? sptDate[0].split('/')
          : sptDate;
      if (sptDate[0] && !regex.test(sptDate[0])) {
        errorDate = true;
      }
      if (
        !validDate(new Date(event.target.value)) &&
        splitDate[2]?.length !== 2
      ) {
        errorDate = true;
      }
      if (
        splitDate.length == 3 &&
        (splitDate[2].length == 1 || splitDate[0] > 12)
      ) {
        errorDate = true;
      }
      if (
        splitDate.length == 3 &&
        (splitDate[2] == 0 || splitDate[1] == 0 || splitDate[0] == 0)
      ) {
        errorDate = true;
      }
      if (
        splitDate.length == 3 &&
        (splitDate[2].length == 3 || splitDate[2].length == 1)
      ) {
        errorDate = true;
      }
      if (
        splitDate.length == 2 &&
        (splitDate[1].length == 1 || splitDate[0] > 12)
      ) {
        errorDate = true;
      }
      if (splitDate.length == 2 && (splitDate[1] == 0 || splitDate[0] == 0)) {
        errorDate = true;
      }
      if (invoiceDate && splitDate.length == 1) {
        errorDate = true;
      }
      if (errorDate) {
        const data = {
          ...searchContractState,
          errorInvalidDate: true,
          minDateError: false,
        };
        dispatch(searchContractActions(data));
        const errorShown = [...errorOthersearchContract];
        let error = errorShown.filter(
          (e) =>
            e !== constantMessageData.AS_OF_DATE_REQUIRED &&
            e !== constantMessageData.MINIMUM_AS_OF_DATE
        );
        error = [
          ...new Set([...error, constantMessageData.DATE_INVALID_FORMAT_ERROR]),
        ];
        dispatch(errorOtherSearchContractActions(error));
        return false;
      }
      if (
        validDate(new Date(event.target.value)) &&
        compareTwoDatesGreaterThanOrEqual(event.target.value, moment(MinDate))
      ) {
        const data = {
          ...searchContractState,
          [name]: event.target.value,
          errorInvalidDate: false,
          minDateError: true,
          errorDateRequired: false,
        };
        dispatch(searchContractActions(data));
        const errorShown = [...errorOthersearchContract];
        let error = errorShown.filter(
          (e) =>
            e !== constantMessageData.DATE_INVALID_FORMAT_ERROR &&
            e !== constantMessageData.AS_OF_DATE_REQUIRED
        );
        error = [
          ...new Set([...error, constantMessageData.MINIMUM_AS_OF_DATE]),
        ];
        dispatch(errorOtherSearchContractActions(error));
      } else {
        let finalDate;
        const inDate = event.target.value;
        const sptDate =
          invoiceDate && invoiceDate.includes('_')
            ? invoiceDate.split('_')
            : invoiceDate;
        const invDate =
          sptDate && sptDate.length > 0 && sptDate[0].includes('/')
            ? sptDate[0].split('/')
            : sptDate;
        const dateLength = invDate.length;
        // detailTab.errorInvalidWirteOffDate = false;
        if (dateLength == 2 && invDate[1].length == 2) {
          const years2D =
            invDate[1].length == 2 && invDate[1] < 43
              ? `20${invDate[1]}`
              : `19${invDate[1]}`;
          const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
          finalDate = `${month}/` + '01' + `/${years2D}`;
          const data = {
            ...searchContractState,
            [name]: finalDate,
            errorInvalidDate: false,
            errorDateRequired: false,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorOthersearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.AS_OF_DATE_REQUIRED
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.DATE_INVALID_FORMAT_ERROR
          );
          dispatch(errorOtherSearchContractActions(error));
        } else if (dateLength == 2 && invDate[1].length == 4) {
          const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
          finalDate = `${month}/` + '01' + `/${invDate[1]}`;
          const data = {
            ...searchContractState,
            [name]: finalDate,
            errorInvalidDate: false,
            errorDateRequired: false,
            minDateError: false,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorOthersearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.AS_OF_DATE_REQUIRED
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.DATE_INVALID_FORMAT_ERROR
          );
          dispatch(errorOtherSearchContractActions(error));
        } else if (dateLength == 3 && invDate[2].length == 2) {
          const years2D =
            invDate[2].length == 2 && invDate[2] < 43
              ? `20${invDate[2]}`
              : `19${invDate[2]}`;
          const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
          finalDate = `${month}/${invDate[1]}/${years2D}`;
          const data = {
            ...searchContractState,
            [name]: finalDate,
            errorInvalidDate: false,
            errorDateRequired: false,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorOthersearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.AS_OF_DATE_REQUIRED
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.DATE_INVALID_FORMAT_ERROR
          );
          dispatch(errorOtherSearchContractActions(error));
        } else if (dateLength == 3 && invDate[2].length == 4) {
          const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
          const day = invDate[1].length < 2 ? `0${invDate[1]}` : invDate[1];
          finalDate = `${month}/${day}/${invDate[2]}`;
          const data = {
            ...searchContractState,
            [name]: finalDate,
            errorInvalidDate: false,
            errorDateRequired: false,
            minDateError: false,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorOthersearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.AS_OF_DATE_REQUIRED
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.DATE_INVALID_FORMAT_ERROR
          );
          dispatch(errorOtherSearchContractActions(error));
        } else {
          const data = {
            ...searchContractState,
            [name]: event.target.value,
            errorInvalidDate: false,
            errorDateRequired: false,
            minDateError: false,
          };
          dispatch(searchContractActions(data));
          const errorShown = [...errorOthersearchContract];
          const error1 = errorShown.filter(
            (e) => e !== constantMessageData.AS_OF_DATE_REQUIRED
          );
          const error = error1.filter(
            (e) => e !== constantMessageData.DATE_INVALID_FORMAT_ERROR
          );
          dispatch(errorOtherSearchContractActions(error));
        }
      }
    } else if (event.target.value === '') {
      const data = {
        ...searchContractState,
        [name]: null,
        errorInvalidDate: false,
        minDateError: false,
        errorDateRequired: true,
      };
      dispatch(searchContractActions(data));
      const errorShown = [...errorOthersearchContract];
      let error = errorShown.filter(
        (e) =>
          e !== constantMessageData.DATE_INVALID_FORMAT_ERROR &&
          e !== constantMessageData.MINIMUM_AS_OF_DATE
      );
      error = [...new Set([...error, constantMessageData.AS_OF_DATE_REQUIRED])];
      dispatch(errorOtherSearchContractActions(error));
    }
  };
  const onCloseCreateContract = () => {
    setOpenCreatePopup(false);
    dispatch(dispatchAllMfgIdUsingRebateProg([]));
    dispatch(dispatchAllDrugFamiliesUsingMfgId([]));
    const newData = {
      ...searchContractState,
      createPlanType: 'ST',
      createRebateProgramCode: '-1',
      selectedCreateMfgRowData: {},
    };
    dispatch(searchContractActions(newData));
  };
  const resetFieldData = () => {
    dispatch(
      maintainContractActions({
        contractSeqNum: '',
        contractName: '',
        contractStartDate: null,
        contractEndDate: null,
        errorContractName: false,
        errorStartDate: false,
        errorEndDate: false,
        errorInvalidStartDate: false,
        errorInvalidEndDate: false,
        corrLinkId: null,
        showSaveButton: 'No',
        disableDrugFamilyTab: true,
        disableCoverageTab: false,
        disableCalTab: false,
        calTab: {
          cmsNdcInclInd: false,
          nonCmsNdcInclInd: false,
          contractCalcMethodCd: '-1',
          calcNonInnovPct: '',
          calcInnovSinglePct: '',
        },
        detailTab: {
          detailInvoices: '-1',
          disputeSpecialists: '-1',
          letterSender: '-1',
          earliestQuarter: '',
          errorInvalidQuarter: false,
          sendToCommercialMfgInd: false,
          useDefRpcInd: false,
          writeOffDate: null,
          writeOffDatePop: null,
          errorInvalidWirteOffDate: false,
          errorInvalidWirteOffDatePop: false,
        },
        manufacturerTab: {
          paperFinalQtr: null,
          printImageFinalQtr: null,
          cmsElectFinalQtr: null,
          ncpdpSummaryFinalQtr: null,
          ncpdpClaimOwnFinalQtr: null,
          ncpdpClaimMbFinalQtr: null,
          useDefMfgInd: 0,
          useDefRpcInd: 0,
          paperInd: 0,
          printImageInd: 0,
          cmsElectInd: 0,
          ncpdpSummaryInd: 0,
          ncpdpClaimOwnInd: 0,
          ncpdpClaimMbInd: 0,
          sendToCommercialMfgInd: 0,
          contractValidInd: 0,
          pricingTimingCd: '-1',
          enrollmentTimingCd: '-1',
          detailLevelOnInvoiceCd: null,
          collectionMediumCd: '-1',
          contractDefDispSpecialist: null,
          letterSenderUserId: null,
          invContactSeqNum: null,
          dispContactSeqNum: null,
          writeOffDt: null,
        },
        invoiceContact: {
          manufacturerID: '',
          manufacturerName: '',
          contactTypeCode: '',
          description: '',
          contactName: '',
          corpName: '',
          addrLine1: '',
          addrLine2: '',
          addrLine3: '',
          city: '',
          stateCd: '',
          zip: '',
          zip4: '',
          phoneNum: '',
          phoneExtension: '',
          faxNum: '',
          email: '',
        },
        disputeContract: {
          manufacturerID: '',
          manufacturerName: '',
          contactTypeCode: '',
          description: '',
          contactName: '',
          corpName: '',
          addrLine1: '',
          addrLine2: '',
          addrLine3: '',
          city: '',
          stateCd: '',
          zip: '',
          zip4: '',
          phoneNum: '',
          phoneExtension: '',
          faxNum: '',
          email: '',
        },
        errordisputeContract: {
          manufacturerID: '',
          manufacturerName: '',
          contactTypeCode: '',
          description: '',
          invalidPhoneNum: false,
          invalidEmail: false,
        },
        getAllOtherContract: [],
        listOfOtherContact: [],
        otherContract: {
          contactTypeCd: '-1',
          contactName: '',
          corpName: '',
          addrLine1: '',
          addrLine2: '',
          addrLine3: '',
          city: '',
          stateCd: '',
          zip: '',
          zip4: '',
          phoneNum: '',
          phoneExtension: '',
          faxNum: '',
          email: '',
        },
        errorOtherContract: {
          contactName: false,
          corpName: false,
          addrLine1: false,
          city: false,
          stateCd: false,
          zip: false,
          phoneNum: false,
          email: false,
          invalidPhoneNum: false,
          invalidEmail: false,
        },
        drugFamily: {
          drugFamilyQtr: '',
          errorInvalidQuarter: false,
          selectedDrugFamilyAddRow: {},
        },
      })
    );
  };
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || tableData === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows?.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
    }
  }, [gridApi, tableData]);
  return (
    <div className='tabs-container frr-contract' data-testid='ContractSearch'>
      <Spinner load={spinnerLoader} />
      <div className=''>
        <CustomSeparator parent1='Maintain' parent2='Contract Search' />
        {!fullScreenView && (
          <DisplayErrorMessages
            errorMessages={
              selected_type == Constants.MANUFACTURER_REBATE_ID
                ? errorsearchContract
                : errorOthersearchContract
            }
          />
        )}
        <div className='clearfix' />
        <div className='no-margin'>
          {!fullScreenView && (
            <div className='panel mb-3'>
              <div className='row mb-2'>
                <div className='col-9 col-sm-7 col-md-8 col-lg-9'>
                  <RadioGroupComponent
                    labelName='Search By'
                    id='newContract'
                    data-testid='newContract'
                    optionList={radioList || []}
                    filterAction={(e) => {
                      dispatch(selectedType(e));
                      dispatch(getPlanTypeDesc(e));
                      const header =
                        e == Constants.MANUFACTURER_REBATE_ID
                          ? manuFactureHead
                          : e == Constants.SEARCH_CONTRACT_ID
                          ? contractHead
                          : e == Constants.CONTRACT_DRUG_FAMILTY_ID
                          ? drugFamilyHead
                          : e == Constants.CONTRACT_MARKET_BASKET_ID
                          ? marketBasketHead
                          : null;
                      const errorShown = [...errorOthersearchContract];
                      const error = errorShown.filter(
                        (e) =>
                          e !== constantMessageData.NO_RECORDS_FOUND_CONTRACT
                      );
                      dispatch(errorOtherSearchContractActions(error));
                      settableData([]);
                      setColumnDefs(header);
                    }}
                    defaultValue={selection}
                  />
                </div>
                <div className='col-3 col-sm-5 col-md-4 col-lg-3'>
                  <Button
                    className='btn-success same-font-family frr-btn-width-17 mt-4'
                    data-testid='createNewContract'
                    type='button'
                    onClick={createNewContract}
                    disabled={!isEnablebyRole}
                  >
                    <img className='manufactureImg' alt='' src={createIcon} />
                    Create New Contract
                  </Button>
                </div>
              </div>
              {selected_type == Constants.MANUFACTURER_REBATE_ID ? (
                <div className='row mb-2 '>
                  <div className='col-5 frr-checkInvoiceRadio frr-contract-plan-type frr-two-col-radio'>
                    <RadioGroupComponent
                      data-testid='filter-plan-by-radio-btn'
                      id='filter-plan-by-radio-btn-action'
                      labelName={Constants.PLAN_TYPE}
                      required={false}
                      optionList={planTypeOptions}
                      value={
                        searchContractState.planType
                          ? searchContractState.planType
                          : 'FD'
                      }
                      filterAction={(e) => handleOnChangeEvent(e, 'planTypeCd')}
                      className='log-batch-filter-radio frr-checkInvoiceRadio'
                    />
                  </div>
                  <div className='col-7 pl-0 frr-checkInvoiceRebate '>
                    <div className='mt-2 frr-contract-rebate-program frr-apply-flex-direction'>
                      <fieldset
                        data-testid='radio-box-component'
                        className='custom-fieldset'
                      >
                        <legend aria-hidden='true' className='d-none' />
                        <div className='form-wrapper my-2'>
                          <div className='mui-custom-form with-select'>
                            <TextField
                              id='rebate-program'
                              className='mandate-fields'
                              label='Rebate Program'
                              required
                              data-testid='rebate-Program'
                              fullWidth
                              select
                              placeholder=''
                              InputProps={{ id: 'rebate-program' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='rebateProgramCode'
                              value={
                                searchContractState?.rebateProgramCode
                                  ? searchContractState?.rebateProgramCode
                                  : '-1'
                              }
                              onChange={(e) => {
                                dispatch(
                                  searchContractActions({
                                    ...searchContractState,
                                    enableSave: true,
                                    rebateProgramCode: e.target.value,
                                  })
                                );
                              }}
                              onBlur={(e) => {
                                onBlurField(e, 'rebateProgramCode');
                              }}
                              helperText={
                                searchContractState.errorRebateProg
                                  ? constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
                                  : null
                              }
                              error={
                                searchContractState.errorRebateProg
                                  ? constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
                                  : null
                              }
                            >
                              <MenuItem
                                key=''
                                value='-1'
                                className='frr-dropdown-blank-item'
                              />
                              {rebateProgramCode && rebateProgramCode.length > 0
                                ? rebateProgramCode.map((item) => {
                                    return (
                                      <MenuItem
                                        key={item.rebateProgramCd}
                                        value={item.rebateProgramCd}
                                      >
                                        {item.rebateProgramCd} -{' '}
                                        {item.shortDescr}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </TextField>
                          </div>

                          <div className='mui-custom-form input-md'>
                            <TextField
                              data-testid='Quarter'
                              id='Quarter'
                              label='Quarter'
                              className='mandate-fields'
                              fullWidth
                              required
                              placeholder=''
                              inputProps={{ maxLength: 6 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={searchContractState.getQuarter}
                              onChange={(e) => {
                                onChangeDetailsField(e, 'getQuarter');
                              }}
                              onBlur={(e) => {
                                onBlurQuarter(e, 'getQuarter');
                              }}
                              helperText={
                                searchContractState.errorQuarterRequired
                                  ? constantMessageData.QUARTER_REQUIRED
                                  : searchContractState.errorInvalidQuarter
                                  ? constantMessageData.VALIDATE_QUARTER_VALUE
                                  : null
                              }
                              error={
                                searchContractState.errorQuarterRequired
                                  ? constantMessageData.QUARTER_REQUIRED
                                  : searchContractState.errorInvalidQuarter
                                  ? constantMessageData.VALIDATE_QUARTER_VALUE
                                  : null
                              }
                            />
                          </div>
                          <div className='mui-custom-form input-md pt-3 frr-checkinvoice-search'>
                            <Button
                              className='btn-success same-font-family frr-btn-width-17'
                              data-testid='searchBtn'
                              type='button'
                              onClick={onSearchManufacturerBtn}
                            >
                              <SVGComponent iconName='Icon-search' />
                              Search
                            </Button>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='row mb-2'>
                  <div className='col-5 d-flex frr-align-item-center'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <div className='mui-custom-form input-md col-7'>
                        <KeyboardDatePicker
                          data-test='start-date'
                          className='mandate-fields'
                          id='begindate-picker-dialog'
                          label='As of Date'
                          data-testid='receivedDate'
                          required
                          format='MM/dd/yyyy'
                          minDate={MinDate}
                          maxDate={MaxDate}
                          value={searchContractState?.searchContractDate}
                          onChange={(e) => {
                            handleChangeDate(e, 'searchContractDate');
                          }}
                          placeholder='mm/dd/yyyy'
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onBlur={(e) => {
                            validateDateFormatOnBlur(e, 'searchContractDate');
                          }}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          onKeyDown={async (e) => {
                            if (e.keyCode == 67) {
                              // copy date
                              await window.navigator?.clipboard.writeText(
                                e?.target?.value
                              );
                            }
                          }}
                          helperText={
                            searchContractState?.errorDateRequired
                              ? constantMessageData.AS_OF_DATE_REQUIRED
                              : searchContractState?.errorInvalidDate
                              ? constantMessageData.DATE_INVALID_FORMAT_ERROR
                              : searchContractState?.minDateError
                              ? constantMessageData.MINIMUM_AS_OF_DATE
                              : null
                          }
                          error={
                            searchContractState?.errorDateRequired
                              ? constantMessageData.AS_OF_DATE_REQUIRED
                              : searchContractState?.errorInvalidDate
                              ? constantMessageData.DATE_INVALID_FORMAT_ERROR
                              : searchContractState?.minDateError
                              ? constantMessageData.MINIMUM_AS_OF_DATE
                              : null
                          }
                        />
                      </div>
                    </MuiPickersUtilsProvider>
                    <div>
                      <Button
                        className='btn-success same-font-family frr-btn-width-17 mt-4'
                        data-testid='searchBtn'
                        type='button'
                        onClick={onSearchOtherContract}
                      >
                        <SVGComponent iconName='Icon-search' />
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className='frr-requestmailing-labels panel-body FRR-custom-table tbl-manufacturer-inner'>
            <TableGrid
              ref={gridRef}
              gridHeight={fullScreenView ? '70vh' : 400}
              data-testid='contract-search-table'
              rowData={tableData}
              gridCall={onGridReady}
              columnDefs={columnDefs}
              rowSelection='multiple'
              setSelectedRow={setSelectedRow}
              cellClickedListener={cellClickedListener}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              onSelectionChanged={onSelectionChanged}
              applyFilter={false}
              helpMessage='* On Double Click of Results, system should navigate to Detail page'
              fileName={tableName}
              exportFile
            />
          </div>
        </div>
        <CommonModal
          open={openCreatePopup}
          viewAction
          viewHeader
          modalTitle='Select a Rebate Program code'
          className='panel-header'
          onClose={onCloseCreateContract}
          childrenComponent={
            <CreateContractModal
              planTypeOptionsCreatePopup={planTypeOptionsCreatePopup}
              onClickCreateContractDailog={onClickCreateContractDailog}
              onCloseCreateContract={onCloseCreateContract}
            />
          }
        />
      </div>
    </div>
  );
};
export default withRouter(ContractSearch);
